import StarBorder from '../Reusable/StarBorder';
import { imagePath } from '../../utils/imagePath';

const Companies = () => {
  const LogoCloud = [
    { name: 'Brand Power', image: imagePath.BrandPower },
    { name: 'Medha', image: imagePath.Medha },
    { name: 'Ministry of Defence', image: imagePath.MinistryOfDefence },
    { name: 'Raghava', image: imagePath.RaghavaCompany },
    { name: 'ISRO', image: imagePath.ISRO },
    { name: 'SCCL', image: imagePath.SCCL },
    { name: 'NRSC', image: imagePath.NRSC },
    { name: 'RST', image: imagePath.RSTCompany },
    { name: 'Americana', image: imagePath.AmericanaCompany },
    { name: 'Life Sciences', image: imagePath.LifeSciences },
  ];

  const row1 = LogoCloud.slice(0, 5);
  const row2 = LogoCloud.slice(5, 9);
  const row3 = LogoCloud.slice(9, 11);

  const widthMap = {
    1: 'w-[90%]',
    2: 'w-[60%]',
    8: 'w-[90%]',
    5: 'w-[45%]',
  };

  const mobileWidthMap = {
    1: 'w-26',
    4: 'w-12',
    2: 'w-14',
    5: 'w-16',
    8: 'w-28',
    9: 'w-26',
  };

  return (
    <div className="py-10 min-h-screen px-4 md:px-20 flex flex-col items-center justify-center">
      {/* HEADER */}
      <div className="max-w-5xl text-center mx-auto space-y-4">
        <StarBorder color="red" thickness={1.5} speed="4s">
          Companies Using
        </StarBorder>

        <h1 className="text-3xl md:text-5xl font-telegraf font-medium text-white">
          Spatial Grid
        </h1>
      </div>

      {/* ================= MOBILE (3-COLUMN GRID) ================= */}
      <div className="mt-16 grid grid-cols-2 gap-6 place-items-center md:hidden px-3">
        {LogoCloud.map((company, i) => (
          <div
            key={i}
            className=" p-6 bg-[#191A1D] rounded-lg flex items-center justify-center text-center hover:bg-[#171616] transition duration-300 w-full h-[120px] transform hover:scale-105 "
          >
            <img
              src={company.image}
              alt={company.name}
              className={` ${mobileWidthMap[i] ?? 'w-24'}   object-contain transition-transform duration-500 ease-in-out hover:scale-110`}
            />
          </div>
        ))}
      </div>

      {/* ================= DESKTOP (UNCHANGED) ================= */}
      <div className="hidden md:block mt-16 space-y-10">
        <div className="grid grid-cols-5 justify-center gap-12 px-14   max-w-[86rem]">
          {LogoCloud.map((company, i) => (
            <div
              key={i}
              className=" p-6 bg-[#191A1D] rounded-lg flex items-center justify-center text-center hover:bg-[#171616] transition duration-300  transform hover:scale-105 aspect-[4/3]"
            >
              <img
                src={company.image}
                alt={company.name}
                className={`${widthMap[i] ?? 'w-[70%]'} h-full object-contain transition-transform duration-500 ease-in-out hover:scale-110`}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Companies;
